import React, { useEffect, useState } from 'react';
import DataTable from '../../../../Components/Others/DataTable';
import { CancelButton, CreateButton, FilterButton, ImportButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import { Link, useLocation } from 'react-router-dom';
import SearchBar from '../../../../Components/Utils/SearchBar';
import UseGetData from '../../../../Components/Hooks/useFetchData';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';
import MoreOptions from '../../../../Components/Utils/MoreOptions';
import GRNTable from './GRNTable';
import * as yup from 'yup';
import UseGetDataSearch from '../../../../Components/Hooks/useFetchDataBySearch';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import { useFormik } from 'formik';
import useFetchMataData from '../../../../Components/Hooks/useFetchMataData';
import { NuDate } from '../../../../Components/Utils/Input';
import Importdoc from './Importdoc';
import ModalContainer from '../../../../Components/Others/ModalContainer';
import MultiEditGRN from './MultiEditGRN';
import { GetAccess } from '../../../../Components/Utils/roles';
import useFetchMDIndex from '../../../../Components/Hooks/useFetchMDIndex';
import ViewToggle from '../../../../Components/Utils/ViewToggle';

function GRNIndex() {

  const location = useLocation();
  const currentPage = location.state?.currentPage
  const searchQuery = location.state?.searchQuery
  const [page, setPage] = useState(currentPage || 1)
  const [pageCount, setPageCount] = useState(localStorage.getItem("perPageView") || 20)
  const [viewMode, setViewMode] = useState(
    localStorage.getItem("grnViewMode") || "table"
  );
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 768 : false
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const effectiveViewMode = isMobile ? "card" : (viewMode === "list" ? "table" : viewMode);

  const state = location.state;
  const [filter, setFilter] = useState(state?.status ? true : false);
  const [showFilterDialog, setShowFilterDialog] = useState(false);

  const { value: GrnStatus } = useFetchMDIndex(`/dropdown/dropdown-details/`, 'GrnStatus', showFilterDialog)
  const { value: PurchaseType } = useFetchMDIndex(`/dropdown/dropdown-details/`, 'GrnpurchaseType', showFilterDialog)
  const [filterProps, setFilterProps] = useState({
    status: "",
    purchaseType: "",
    receivedDateFrom: "",
    receivedDateTo: "",
  });
  const [params, setParams] = useState({
    page: page,
    per_page: pageCount,

    search: searchQuery || "",

    status: state?.status ? state.status : "",

    purchaseType: "",
    receivedDateFrom: "",
    receivedDateTo: "",
  });

  const clearFilter = () => {
    setParams({
      ...params, status: "",
      purchaseType: "",
      receivedDateFrom: "",
      receivedDateTo: "",
    })
    setFilter(false)
    formik.values.status = ""
    formik.values.purchaseType = ""
    formik.values.receivedDateFrom = ""
    formik.values.receivedDateTo = ""

  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterProps,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      // email: yup.string().required('Email is required!'),
    }),
    onSubmit: async (value, { resetForm }) => {
      console.log("ffff", value);
      setParams({ ...params, status: value.status, purchaseType: value.purchaseType, receivedDateFrom: value.receivedDateFrom, receivedDateTo: value.receivedDateTo })
      closeFilterDialog();
      setFilter(true)
      setFilterProps({
        status: "",
        purchaseType: "",
        receivedDateFrom: "",
        receivedDateTo: "",
      });
    }
  })

  const { data, totalCount, getData, dataLoading } = UseGetDataSearch('/grn/', params);

  const defaultHeader = [
    {
      title: "YPR",
      width: "10%",
      isLink: true,
      id: "id",
      link: '/store/grn/view/',
      field: "prRef",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "GRN No.",
      width: "10%",
      isLink: true,
      id: "id",
      link: '/store/grn/view/',
      field: "ref",
      textAlign: "center",
      rowAlign: "center",
    },

    {
      title: "PO No.",
      width: "10%",
      field: "poRef",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Supplier",
      width: "10%",
      field: "vendorName",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "DN No.",
      width: "10%",
      field: "dnRef",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Busy GRN No.",
      width: "10%",
      field: "busyGrnNo",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Recvd Date",
      width: "10%",
      field: "receivedDate",
      type: "date",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Status",
      width: "10%",
      field: "status",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Action",
      width: "5%",
      field: "action",
      textAlign: "center",
      rowAlign: "center",
      contents: {
        id: "id",
        removeValue: "poRef",
        url: `/grn/`,
        moduleName: 'GRN',
        from: `/store/grn`,
        editLink: '/store/grn/edit/',
        viewLink: '/store/grn/view/',

      }
    },
  ];
  const availableHeaders = [
    {
      title: "YPR",
      width: "10%",
      isLink: true,
      id: "id",
      link: '/store/grn/view/',
      field: "prRef",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "GRN No.",
      width: "10%",
      isLink: true,
      id: "id",
      link: '/store/grn/view/',
      field: "ref",
      textAlign: "center",
      rowAlign: "center",
    },

    {
      title: "PO No.",
      width: "10%",
      field: "poRef",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Supplier",
      width: "10%",
      field: "vendorName",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "DN No.",
      width: "10%",
      field: "dnRef",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Busy GRN No.",
      width: "10%",
      field: "busyGrnNo",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Recvd Date",
      width: "10%",
      field: "receivedDate",
      type: "date",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Status",
      width: "10%",
      field: "status",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Verified By",
      width: "10%",
      field: "verifiedByName",
      textAlign: "center",
      rowAlign: "center",
    },

    {
      title: "Action",
      width: "5%",
      field: "action",
      textAlign: "center",
      rowAlign: "center",
      contents: {
        id: "id",
        removeValue: "poRef",
        url: `/grn/`,
        moduleName: 'GRN',
        from: `/store/grn`,
        editLink: '/store/grn/edit/',
        viewLink: '/store/grn/view/',

      }
    },
  ];
  useEffect(() => {
    setParams({ ...params, page: page, per_page: pageCount })
  }, [page, pageCount])

  const closeFilterDialog = () => {
    setShowFilterDialog(false);
  };

  const [showImportModal, setShowImportModal] = useState(false);

  const handleImportClick = () => {
    setShowImportModal(true);
  };

  const closeModal = () => {
    setShowImportModal(false);
  };
  const [showEdit, setShowEdit] = useState(false)
  const [showDelete, setShowDelete] = useState(false)
  const [listofNumbers, setListofNumbers] = useState([])
  const [fullList, setFullList] = useState([])

  const selectOneFunction = (value) => {
    let NewId;
    if (listofNumbers && listofNumbers.some(Item => Item === value)) {
      NewId = listofNumbers.filter(Temp => Temp !== value);
      setListofNumbers(NewId)
    } else {
      setListofNumbers([...listofNumbers, value])
    }
  }

  const selectMultipleFunction = (e) => {
    if (e.target.checked) {
      setListofNumbers(fullList)
    } else {
      setListofNumbers([])
    }

  }

  useEffect(() => {
    let tempArr = []
    data && data.forEach(i => {
      tempArr.push(i?.id)
    });
    setFullList(tempArr)
  }, [data])


  return (
    <div className='w-full h-full px-2 sm:px-4 py-2'>
      <div className='w-full flex flex-col md:flex-row justify-between items-stretch md:items-center gap-2 md:gap-3 mb-3'>
        <div className='w-full md:w-auto flex justify-between items-center gap-2'>
          <Breadcrumb
            items={[
              { name: "Store" },
              { name: "GRN" },
            ]}
          />
          <div className='flex md:hidden items-center gap-2'>
            <FilterButton handleClick={() => setShowFilterDialog(true)} />
            {filter && <FilterButton handleClick={() => clearFilter()} label='Clear' />}
            {GetAccess("grn_create") && <Link to="/store/grn/create"><CreateButton label='GRN' /></Link>}
          </div>
        </div>

        <div className='w-full md:w-auto flex flex-wrap md:flex-nowrap items-center gap-2'>
          <div className="w-full md:w-fit">
            <SearchBar
              handleChange={(e) => {
                setParams({ ...params, search: e.target.value, page: 1 });
                setPage(1);
              }}
              value={params.search}
            />
          </div>
          <div className='hidden md:flex items-center gap-2'>
            <FilterButton handleClick={() => setShowFilterDialog(true)} />
            {filter && <FilterButton handleClick={() => clearFilter()} label='Clear' />}
          </div>

          <ViewToggle
            viewMode={effectiveViewMode}
            onViewChange={(mode) => setViewMode(mode)}
            storageKey="grnViewMode"
          />
          <div className='hidden md:flex items-center gap-2'>
            {GetAccess("grn_create") && <Link to="/store/grn/create"><CreateButton label='GRN' /></Link>}
          </div>
        </div>
      </div>

      <GRNTable
        data={data}
        total={totalCount}
        pageIndex={page}
        setPageIndex={setPage}
        dataCount={pageCount}
        setDataCount={setPageCount}
        searchQuery={params?.search !== "" ? params?.search : ""}
        listofNumbers={listofNumbers}
        selectOneFunction={selectOneFunction}
        selectMultipleFunction={selectMultipleFunction}
        fullList={fullList}
        fetcher={getData}
        dataLoading={dataLoading}
        showEdit={showEdit}
        setShowEdit={setShowEdit}
        viewMode={effectiveViewMode}
      />
      {showFilterDialog && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center p-3 sm:p-4">
          <div className="animate-scale-in w-full sm:w-[520px] max-w-[95vw] max-h-[90vh] bg-white py-4 px-4 sm:px-6 rounded-xl shadow-lg overflow-y-auto">
            <h2 className="text-lg font-bold text-gray-800 mb-4">Filter GRN</h2>
            <form onSubmit={formik.handleSubmit}>
              <div className="flex flex-col gap-3 mb-4">
                <div>
                  <p className="py-1 text-xs font-semibold text-gray-700">Received Date</p>
                  <div className="flex flex-col sm:flex-row gap-2 w-full">
                    <NuDate
                      label="From"
                      placeholder="dd/mm/yyyy"
                      formik={formik}
                      name="receivedDateFrom"
                      width="w-full"
                    />
                    <NuDate
                      label="To"
                      placeholder="dd/mm/yyyy"
                      formik={formik}
                      name="receivedDateTo"
                      width="w-full"
                    />
                  </div>
                </div>
                <FormikSelectTwo
                  type="text"
                  label="Status"
                  placeholder="Status"
                  Options={GrnStatus}
                  formik={formik}
                  name="status"
                  width="w-full "
                />
              </div>
              <div className="flex justify-end gap-2 pt-2 border-t border-gray-100">
                <CancelButton handleClick={closeFilterDialog} />
                <SubmitButton name='Apply' />
              </div>
            </form>
          </div>
        </div>
      )}
      {showImportModal && (<Importdoc show={showImportModal} onClose={closeModal} getData={getData} />)}
      {showEdit && (<MultiEditGRN data={listofNumbers} getData={getData} onClose={() => setShowEdit(false)} />)}
      <ModalContainer
        visiable={showDelete}
        title="Warning"
        content={`Are you sure, All selected datas will be removed from YPR List!`}
        handleClick={() => { }}
        closeModal={() => setShowDelete(false)}
      />
    </div>
  )
}

export default GRNIndex